'use client'

/* eslint-disable @typescript-eslint/no-floating-promises */

import React from 'react'
import AutoWidgetOldLayout from './autoWidgetOldLayout'
import AutoWidgetNewLayout from './autoWidgetNewLayout'
import { type AutoWidgetProps } from './interfaces'

const AutoWidget = (props: AutoWidgetProps) => {
  const { isOldLayout = false, regexPatternsData, ...restProps } = props

  return isOldLayout ? (
    <AutoWidgetOldLayout regexPatternsData={regexPatternsData} {...restProps} />
  ) : (
    <AutoWidgetNewLayout regexPatternsData={regexPatternsData} {...restProps} />
  )
}

export default AutoWidget
